import { useEffect, useState } from 'react';
import { apiFetch } from '../config/api';

export default function StaffWebviewBootstrap({ token, onComplete }) {
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function consumeSession() {
      const sessionToken = String(token || '').trim();
      if (!sessionToken) {
        setError('Missing staff session token.');
        return;
      }

      try {
        const res = await apiFetch('/auth/staff/webview-session/consume', {
          method: 'POST',
          body: JSON.stringify({ token: sessionToken }),
        });

        if (cancelled) return;
        onComplete({
          ...(res.user || {}),
          token: res.token,
        });
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Unable to open staff dashboard.');
        }
      }
    }

    consumeSession();

    return () => {
      cancelled = true;
    };
  }, [onComplete, token]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        className="glass-card"
        style={{
          width: 'min(100%, 420px)',
          padding: '32px 28px',
          textAlign: 'center',
          color: '#fff',
        }}
      >
        <h1 style={{ margin: 0, fontSize: 24 }}>Staff Dashboard</h1>
        <p style={{ margin: '14px 0 0', color: 'rgba(255,255,255,0.86)', lineHeight: 1.5 }}>
          {error || 'Opening dismissal board...'}
        </p>
      </div>
    </div>
  );
}
